export default "__VITE_ASSET__181e7b86__"